import { Modal, Dropdown, Image, Button, message, Tooltip } from "antd";
import { useNavigate } from "react-router-dom";
import StarRound from "../../../assets/star-round.svg";
import StarEmpty from "../../../assets/star_black.png";
// import CopyIcon from '../../../assets/copy-icon-1.svg';
import IconShow from '../../../assets/show-icon_eyes.png';
import DeleteIcon from '../../../assets/delete-icon.png';
import SendIcon from '../../../assets/send-icon.png';
import { CaretDownFilled, LeftOutlined, RightOutlined } from "@ant-design/icons";
import { useEffect, useRef, useState } from "react";
import MaterialTable from "material-table";
import SendEmailNotification from "./SendEmailNotification";
import tableIcons from '../../../utils/tableIcons';
import Loader from '../../../components/shared/Loader';
import { DeleteServiceProvider, GetServiceProviders, UpdateServiceProvider } from "../../../utils/api";
import { useGlobalContext } from "../../../context/GlobalProvider";
import { imgPath } from "../../../utils/axiosInstance";
import Logo from '../../../assets/logo.png';

const Onboarded = ({ modalData, setModalData }) => {

  const { serviceProviderActiveTab, onboardedPage, setOnboardedPage } = useGlobalContext();
  const tableRef = useRef(null);
  const navigate = useNavigate();
  const [notificationDrawerData, setNotificationDrawerData] = useState({ visible: false, data: null });
  const [query, setQuery] = useState({
    page: 0,
    pageSize: 10,
    search: '',
    orderField: '',
    orderDirection: '',
  });
  const [btnLoading, setBtnLoading] = useState(false);

  const dropdownItems = [
    {
      label: 'Active',
      key: 'active',
    },
    // {
    //   label: 'Inactive',
    //   key: 'inactive',
    // },
    {
      label: 'Block',
      key: 'blocked',
    },
  ];

  const columns = [
    {
      title: 'Id',
      field: 'id',
      sorting: true,
      cellStyle: { width: '8%' },
    },
    {
      title: 'Business Name',
      field: 'business_name',
      cellStyle: { width: '17%' },
      sorting: true,
      render: (record) => (
        <div className='flex relative items-center gap-x-3'>
          <Image alt={record.business_name} src={record?.image ? `${imgPath}${record?.image}` : Logo} width={24} height={24} className='flex-shrink-0 rounded-full' />
          {
            record.isFeatured === 2 ?
              <img className='absolute top-4 left-4' src={StarRound} alt="star-round" /> : null
          }
          <span className="cursor-pointer" onClick={(e) => handleNavigateToProfile(e, record)}>{record.business_name}</span>
        </div>
      ),
    },
    {
      title: 'Name',
      field: 'user_name',
      sorting: true,
      cellStyle: { width: '12%' },
    },
    {
      title: 'Location',
      field: 'business_location',
      sorting: false,
      cellStyle: { width: '22%' },
    },
    {
      title: 'Total Book Now Clicks',
      field: 'booking_counter',
      render: (record) => {
        return (
          <span>{record.booking_counter || 0}</span>
        )
      },
      sorting: true,
      cellStyle: { width: '15%' },
    },
    {
      title: 'Profile Views',
      field: 'profile_view',
      sorting: true,
      cellStyle: { width: '8%' },
    },
    {
      title: 'Status',
      field: 'statusType',
      cellStyle: { width: '5%' },
      sorting: false,
      align: 'center',
      render: (record) => {
        let updatedItems = dropdownItems.filter((item) => {
          return item.key !== record.statusType;
        });
        if (record.statusType === 'blocked') {
          updatedItems = [
            {
              key: 'unblocked',
              label: 'Unblock',
            },
          ];
        }
        if (record.statusType === 'active') {
          updatedItems = [
            // {
            //   label: 'Inactive',
            //   key: 'inactive',
            // },
            {
              label: 'Block',
              key: 'blocked',
            },
          ];
        }
        if (record.statusType === 'inactive') {
          updatedItems = [
            {
              label: 'Active',
              key: 'active',
            },
            {
              label: 'Block',
              key: 'blocked',
            },
          ];
        }
        return (
          <div className='cursor-pointer' onClick={(e) => e.stopPropagation()}>
            <Dropdown
              menu={{
                items: updatedItems,
                onClick: (e) => handleActionModalOpen('changeStatus', e?.key, record)
              }}
              trigger={['click']}>
              <div className='flex items-center justify-end gap-x-1'>
                <span className={`capitalize ${record.statusType === 'active' ? 'text-[green]' : record.statusType === 'inactive' ? 'text-orange' : record.statusType === 'blocked' ? 'text-[red]' : 'text-black-900'}`}>
                  {record.statusType}
                </span>
                <button className='text-[10px]'>
                  <CaretDownFilled />
                </button>
              </div>
            </Dropdown>
          </div>
        );
      },
    },
    {
      title: 'Actions',
      sorting: false,
      cellStyle: { width: '14%' },
      align: 'center',
      render: (record) => (
        <div className='flex items-center justify-center gap-x-3'>
          {/* <Tooltip title={record?.booking_link} color="#61373f" arrow={false}>
            <img alt='copy-icon' src={CopyIcon} width={13} onClick={e => copyLink(e, record?.booking_link)} className='cursor-pointer' />
          </Tooltip> */}
          <img alt='send-icon' src={SendIcon} width={18} onClick={(e) => handleSendEmail(e, record)} className='cursor-pointer' />
          <img alt='star' src={record.isFeatured === 2 ? StarRound : StarEmpty} width={18} onClick={(e) => { e.stopPropagation(); handleActionModalOpen('spotlight', record?.isFeatured, record); }} className='cursor-pointer' />
          <img alt='show-icon' src={IconShow} width={18} onClick={(e) => handleNavigateToProfile(e, record)} className='cursor-pointer' />
          <img alt='delete-icon' src={DeleteIcon} width={18} onClick={(e) => { e.stopPropagation(); handleActionModalOpen('delete', 'deleted', record); }} className='cursor-pointer' />
        </div>
      ),
    },
  ];

  // const copyLink = (e, link) => {
  //   e.stopPropagation();
  //   message.destroy();
  //   if (link) {
  //     navigator.clipboard.writeText(link);
  //     message.success(`Link copied - ${link}`);
  //   } else {
  //     message.error('Failed to copy link')
  //   }
  // }

  const handleNavigateToProfile = (e, record) => {
    e.stopPropagation();
    setOnboardedPage(query.page);
    navigate(`/admin/service-providers/${record.id}`, { state: { type: 'onboarded' } });
  }

  const fetchData = async (dataquery) => {

    let params = 'profileStage=approved';

    if (dataquery?.search) {
      params += `&search=${dataquery.search}`;
    }

    if (dataquery?.orderBy) {
      params += `&sort=${dataquery?.orderBy.field}&order=${dataquery?.orderDirection}`;
    }

    params += `&pageNo=${dataquery?.page + 1}`;

    params += `&limit=${dataquery?.pageSize}`;

    const response = await GetServiceProviders(params);
    setOnboardedPage(0);

    return {
      data: response?.items,
      page: dataquery?.page,
      totalCount: response?.totalRecords
    };
  };

  const handleSendEmail = (e, record) => {
    e.stopPropagation();
    setNotificationDrawerData({ visible: true, data: record });
  }

  const handleActionModalOpen = (action, status, user) => {
    if (action === 'delete') {
      setModalData({ visible: true, user: user.business_name, id: user.id, selectedStatus: status, action: 'delete' });
    } else if (action === 'changeStatus') {
      setModalData({ visible: true, user: user.business_name, selectedStatus: status, id: user.id, action: 'changeStatus' });
    }
    else if (action === 'spotlight') {
      setModalData({ visible: true, user: user.business_name, selectedStatus: status, id: user.id, action: 'spotlight' });
    }

  };

  const handleChangeStatusOk = async () => {
    if (modalData.action === 'changeStatus') {
      try {
        setBtnLoading(true);
        const res = await UpdateServiceProvider({ statusType: modalData?.selectedStatus === 'unblocked' ? 'active' : modalData?.selectedStatus }, modalData?.id);
        if (res?.isSuccess) {
          message.success('Service Provider status updated successfully');
          setModalData({ selectedStatus: null, user: null, id: null, visible: false, action: null });
          setBtnLoading(false);
          tableRef.current.onQueryChange();
        } else {
          message.error(res?.error);
          setBtnLoading(false);
        }
      } catch (error) {
        setBtnLoading(false);
        message.error('Error in updating status, Try again later');
      }
    }
  }
  const handleAddRemoveFromSpotlight = async () => {
    if (modalData.action === 'spotlight') {
      try {
        setBtnLoading(true);
        const res = await UpdateServiceProvider({ is_featured: modalData?.selectedStatus === 0 ? 2 : '0' }, modalData?.id);
        if (res?.isSuccess) {
          message.success(`Service Provider ${modalData?.selectedStatus === 0 ? 'added to' : 'removed from'} spotlight successfully`);
          setModalData({ selectedStatus: null, user: null, id: null, visible: false, action: null });
          setBtnLoading(false);
          tableRef.current.onQueryChange();
        } else {
          message.error(res?.error);
          setBtnLoading(false);
        }
      } catch (error) {
        setBtnLoading(false);
        message.error('Error in updating status, Try again later');
      }
    }
  }

  const handleDeleteOk = async () => {
    if (modalData.action === 'delete') {
      try {
        setBtnLoading(true);
        const res = await DeleteServiceProvider({ statusType: modalData?.selectedStatus }, modalData?.id);
        setBtnLoading(false);
        if (res?.isSuccess) {
          message.success('Service Provider Deleted successfully');
          setModalData({ id: null, visible: false, selectedStatus: null, user: null, action: null });
          tableRef.current.onQueryChange();
        }
      } catch (error) {
        setBtnLoading(false);
        message.error('Error in deletion, Try again later');
      }
    }
  }

  // const handleAddRemoveToSpotLight = async()={
  //   if (modalData.action === 'spotlight') {
  //     try {
  //         setBtnLoading(true);
  //         const res = await UpdateServiceProvider({ is_featured: modalData?.value }, id);
  //         setBtnLoading(false);
  //         if (res?.isSuccess) {
  //             message.success('Service provider spotlight status successfully');
  //             setModalData({ id: null, visible: false, selectedStatus: null, user: null, action: null });
  //             getServiceById();
  //         }
  //     } catch (error) {
  //         setBtnLoading(false);
  //         message.error('Error in Updation, Try again later');
  //     }
  // }
  // }

  const handleModalCancel = () => {
    setModalData({ visible: false, selectedStatus: null, user: null, id: null });
  }

  useEffect(() => {
    tableRef.current.onQueryChange();
  }, [serviceProviderActiveTab]);

  // useEffect(() => {
  //   tableRef.current.onQueryChange({ ...query, page: state?.page });
  // }, [state.page]);

  const overlayContainer = {
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(255, 255, 255, 0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 999,
  }

  return (
    <div className="searchposotion table-scroll poppins">
      <MaterialTable
        title="Clients"
        tableRef={tableRef}
        columns={columns}
        icons={tableIcons}
        page={query.page}
        options={{
          showTitle: false,
          draggable: false,
          paging: true,
          sorting: true,
          search: true,
          pageSize: query.pageSize,
          pageSizeOptions: [10, 25, 50, 100],
          debounceInterval: 700,
          padding: 'dense',
          paginationType: 'stepped',
          searchFieldVariant: 'outlined',
          searchFieldAlignment: 'left'
        }}
        data={query => fetchData(onboardedPage ? { ...query, page: onboardedPage } : query)}
        onChangeRowsPerPage={(pageSize => setQuery(prev => ({ ...prev, pageSize: Number(pageSize) })))}
        onChangePage={(page => setQuery(prev => ({ ...prev, page: Number(page) })))}
        components={{
          Pagination: (props) => {
            const { page, rowsPerPage, count, onChangePage, onChangeRowsPerPage } = props;
            return (
              <div className="box-shadow-pagination text-sm" style={{ position: 'relative', display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '10px 20px', marginTop: '20px' }}>
                <div className='bottom-pagination-text'>
                  <button className='disabled:opacity-50' onClick={(e) => onChangePage(e, page - 1)} disabled={page === 0}><LeftOutlined /></button>
                  <span style={{ margin: '0 10px' }}>{page + 1} of {Math.ceil(count / rowsPerPage)}</span>
                  <button className='disabled:opacity-50' onClick={(e) => onChangePage(e, page + 1)} disabled={page === Math.ceil(count / rowsPerPage) - 1 || tableRef.current?.dataManager?.data?.length === 0}><RightOutlined /></button>
                </div>
                <div style={{ position: 'absolute', right: '25px' }} >
                  <span style={{ margin: '0 10px' }}>Items per page:</span>
                  <select disabled={tableRef.current?.dataManager?.data?.length === 0} className='pagination-select' value={rowsPerPage} onChange={(e) => {
                    onChangeRowsPerPage(e, e.target.value);
                  }}>
                    <option value={10}>10</option>
                    <option value={25}>25</option>
                    <option value={50}>50</option>
                    <option value={100}>100</option>
                  </select>
                </div>
              </div>
            );
          },
          OverlayLoading: (props) => {
            return (
              <div style={overlayContainer}>
                <Loader />
              </div>
            )
          }
        }
        }
      />
      <Modal
        centered
        title={modalData.action === 'delete' ? 'Confirm Delete' : (modalData.action === 'changeStatus' ? 'Confirm Status Change' : `${modalData.selectedStatus === 0 ? 'Add' : 'Remove'} ${modalData.selectedStatus === 0 ? 'to' : 'from'} Spotlight`)}
        open={modalData.visible}
        onCancel={handleModalCancel}
        footer={<div>
          <Button onClick={handleModalCancel}>Cancel</Button>
          <Button type='primary' className='text-white' onClick={modalData.action === 'delete' ? handleDeleteOk : (modalData.action === 'changeStatus' ? handleChangeStatusOk : handleAddRemoveFromSpotlight)}>Ok
            {btnLoading && <span className='loader ml-2 align-middle mb-1'></span>}
          </Button>
        </div>}
      >
        {
          modalData.action === 'changeStatus' ? `Are you sure you want to change the status of ${modalData.user} to ${modalData.selectedStatus}?` : modalData.action === 'delete' ? `Are you sure you want to delete ${modalData.user}?` : `Are you sure you want to ${modalData.selectedStatus === 0 ? 'add' : 'remove'} ${modalData.user} ${modalData.selectedStatus === 0 ? 'to' : 'from'}  spotlight?`
        }
      </Modal>
      <SendEmailNotification notificationDrawerData={notificationDrawerData} setNotificationDrawerData={setNotificationDrawerData} />
    </div>
  )
}

export default Onboarded;